import {gsap} from '../LibrariesImport';
import {GlobalVariables} from '../GlobalVariables';

// Rotations cycliques appliquées aux cartes du slider, dans l'ordre des slides.
const CARD_ROTATIONS = [2, -1, -2];
const MD_BREAKPOINT = 768;

export default class BlockHubs {
	constructor() {
		// Swiper n'est chargé que si la meta has_swiper_block est posée (cf. acf-fields.php) :
		// on sort proprement sinon, pour ne pas stopper l'init des autres composants.
		if (typeof Swiper === 'undefined') {
			return;
		}
		const blocks = document.querySelectorAll('.block-hubs');
		const mm = gsap.matchMedia();

		blocks.forEach((block) => {
			const swiper = block.querySelector('.swiper');
			if (!swiper) {
				return;
			}
			const prev = block.querySelector('.navigation-button-prev');
			const next = block.querySelector('.navigation-button-next');
			const cards = Array.from(swiper.querySelectorAll('.block-hubs-card'));
			const isHoverCapable = document.documentElement.classList.contains('no-touchevents');

			// Rotation des cartes réservée au desktop/tablette (md+) : pas de tilt sur le slider mobile.
			mm.add(`(min-width: ${MD_BREAKPOINT}px)`, () => {
				const listeners = [];

				cards.forEach((card, index) => {
					const baseRotation = CARD_ROTATIONS[index % CARD_ROTATIONS.length];
					gsap.set(card, {rotation: baseRotation});

					if (!isHoverCapable) {
						return;
					}

					const onEnter = () => gsap.to(card, {rotation: 0, duration: 0.4, ease: 'power2.out'});
					const onLeave = () => gsap.to(card, {rotation: baseRotation, duration: 0.4, ease: 'power2.out'});
					card.addEventListener('mouseenter', onEnter);
					card.addEventListener('mouseleave', onLeave);
					listeners.push([card, onEnter, onLeave]);
				});

				return () => {
					listeners.forEach(([card, onEnter, onLeave]) => {
						card.removeEventListener('mouseenter', onEnter);
						card.removeEventListener('mouseleave', onLeave);
					});
					gsap.set(cards, {rotation: 0});
				};
			});

			new Swiper(swiper, {
				slidesPerView: 1.1,
				spaceBetween: 16,
				grabCursor: true,
				breakpoints: {
					992: {
						slidesPerView: 1.5,
						spaceBetween: 24,
					},
				},
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
			});
		});
	}
}
